import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import logo from "../assets/logo.png";
import debounce from "lodash.debounce";

function RecruiterDash() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(2);

  // Debounced search query update
  const debouncedSearch = debounce((searchQuery) => {
    setSearchQuery(searchQuery);
  }, 500);

  const handleSearch = (e) => {
    debouncedSearch(e.target.value);
    setSearch(e.target.value);
  };

  const handleAdd = (event) => {
    event.preventDefault();
    navigate("/form");
  };

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://mocki.io/v1/9f96c11d-9288-434b-96e3-430effffa8bc"
        );
        setData(response.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchData();
  }, []);

  // Delete item handler
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this JD?"
    );
    if (isConfirmed) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_BASE_URL}/api/job_descriptions/${id}/`
        );
        setData(data.filter((item) => item.id !== id));
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  // Filter items based on search query
  const filteredItems = data.filter((item) =>
    item.description?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Paginate filtered items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginatedItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  // Paginate
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg"
        style={{ backgroundColor: "#001F3F" }}
      >
        <div className="container-fluid">
          <Link className="navbar-brand text-white" to="/">
            <img src={logo} alt="logo" width="35" />
            <span className="ms-2 navfont text-white">Screenify</span>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon landnav-toggler"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav ms-auto text-center">
              <li className="nav-item">
                <Link
                  className="nav-link text-white active"
                  aria-current="page"
                  to="#"
                >
                  Logo
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="#">
                  <i className="fa-regular fa-circle-user me-1"></i>
                  Name
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="#">
                  Role
                </Link>
              </li>
              <li className="nav-item dropdown">
                <Link
                  className="nav-link dropdown-toggle text-white"
                  to="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Settings
                </Link>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="#">
                      JD Management
                    </Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="#">
                      Reports
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white" to="/signup">
                  <i className="fa-solid fa-user-plus me-1"></i>
                  Signup
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-white " to="/">
                  <i className="fa-solid fa-right-from-bracket me-1"></i>
                  Logout
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div className="container py-3 mt-1">
        <div className="p-2 mb-5 rounded">
          <h3 className="text-center s">
            <b>Job Description Configurator</b>
          </h3>

          <div className="row">
            <div className="col-sm-3 mt-2 mb-3 text-gred">
              <div className="search">
                <form className="form-inline">
                  <input
                    className="form-control mr-sm-2"
                    type="search"
                    placeholder="Search.."
                    aria-label="Search"
                    onChange={handleSearch}
                    value={search}
                  />
                </form>
              </div>
            </div>

            <div className="col-sm-3 offset-sm-6 mt-1 mb-2 text-center">
              <button
                className="btn text-white"
                onClick={handleAdd}
                style={{ backgroundColor: "#001F3F" }}
              >
                Add
              </button>
            </div>
          </div>
          <div className="row">
            <div className="table-responsive table-sm">
              <table
                className="table border-dark table-hover"
                style={{
                  borderRadius: "5px",
                  overflow: "hidden",
                }}
              >
                <thead>
                  <tr className="table-dark">
                    <th>id</th>
                    <th>Description</th>
                    <th>Mandatory Skills</th>
                    <th>Optional Skills</th>
                    <th>Total&nbsp;Experience</th>
                    <th>Relevant&nbsp;Experience</th>
                    <th>Education</th>
                    <th>Location</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedItems.map((item, index) => (
                    <tr
                      key={item.id}
                      className={
                        index % 2 === 0 ? "table-light" : "table-secondary"
                      }
                    >
                      <td>{item.id}</td>
                      <td>{item.description}</td>
                      <td>{item.mandatory_skills}</td>
                      <td>{item.optional_skills}</td>
                      <td>{item.total_experience}</td>
                      <td>{item.relevant_experience}</td>
                      <td>{item.education}</td>
                      <td>{item.location}</td>
                      <td>
                        <Link
                          to="/upload"
                          className="select"
                          title="Select"
                          data-toggle="tooltip"
                        >
                          <i className="fa-regular fa-square-check me-1"></i>
                        </Link>
                        <Link
                          to={`/edit/${item.id}`}
                          className="edit"
                          title="Edit"
                          data-toggle="tooltip"
                        >
                          <i className="fa fa-edit me-1 ms-1"></i>
                        </Link>
                        <Link
                          to="#"
                          className="delete"
                          title="Delete"
                          data-toggle="tooltip"
                          style={{ color: "red" }}
                          onClick={() => handleDelete(item.id)}
                        >
                          <i className="fa fa-trash"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <nav aria-label="Page navigation example">
            <ul className="pagination justify-content-end mt-1">
              {/* Previous Button */}
              {currentPage > 1 && (
                <li className="page-item">
                  <Link
                    className="page-link"
                    to="#"
                    onClick={() => paginate(currentPage - 1)}
                  >
                    Previous
                  </Link>
                </li>
              )}

              {/* Current Page */}
              <li className="page-item active">
                <Link className="page-link" to="#">
                  {currentPage}
                </Link>
              </li>

              {/* Ellipsis if there's a gap */}
              {currentPage <
                Math.ceil(filteredItems.length / itemsPerPage) - 1 && (
                <li className="page-item">
                  <Link className="page-link" to="#">
                    ...
                  </Link>
                </li>
              )}

              {/* Last Page */}
              {currentPage < Math.ceil(filteredItems.length / itemsPerPage) && (
                <li className="page-item">
                  <Link
                    className="page-link"
                    to="#"
                    onClick={() =>
                      paginate(Math.ceil(filteredItems.length / itemsPerPage))
                    }
                  >
                    {Math.ceil(filteredItems.length / itemsPerPage)}
                  </Link>
                </li>
              )}

              {/* Next Button */}
              {currentPage < Math.ceil(filteredItems.length / itemsPerPage) && (
                <li className="page-item">
                  <Link
                    className="page-link"
                    to="#"
                    onClick={() => paginate(currentPage + 1)}
                  >
                    Next
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
}

export default RecruiterDash;
